var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBriefcase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 7V6C7 4.34315 8.34315 3 10 3H14C15.6569 3 17 4.34315 17 6V7H20C21.1046 7 22 7.89543 22 9V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V9C2 7.89543 2.89543 7 4 7H7ZM9 6C9 5.44772 9.44772 5 10 5H14C14.5523 5 15 5.44772 15 6V7H9V6ZM15 9H9V19H15V9ZM17 19V9H20V19H17ZM7 19H4V9H7V19Z",
    fill: "#040405"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBriefcase);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03IDdWNkM3IDQuMzQzMTUgOC4zNDMxNSAzIDEwIDNIMTRDMTUuNjU2OSAzIDE3IDQuMzQzMTUgMTcgNlY3SDIwQzIxLjEwNDYgNyAyMiA3Ljg5NTQzIDIyIDlWMTlDMjIgMjAuMTA0NiAyMS4xMDQ2IDIxIDIwIDIxSDRDMi44OTU0MyAyMSAyIDIwLjEwNDYgMiAxOVY5QzIgNy44OTU0MyAyLjg5NTQzIDcgNCA3SDdaTTkgNkM5IDUuNDQ3NzIgOS40NDc3MiA1IDEwIDVIMTRDMTQuNTUyMyA1IDE1IDUuNDQ3NzIgMTUgNlY3SDlWNlpNMTUgOUg5VjE5SDE1VjlaTTE3IDE5VjlIMjBWMTlIMTdaTTcgMTlINFY5SDdWMTlaIiBmaWxsPSIjMDQwNDA1Ii8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };